import { getBestFormantMatch } from "../../phonemes/formants";
import { IpaType } from "../../phonemes/ipa";
import { FormantsChart } from "../chart/FormantsChart";

/** formants chart, hilite the current phoneme & the reference phoneme */
export function AccentFormantChart(props: {
  readonly current: IpaType,  /** current phoneme (vowel, diphthong) */
  readonly reference: IpaType, /** reference phoneme */
  readonly list?: IpaType[],  /** list of additional phonemes to show */
  readonly clicked: (ipa: IpaType) => void,
  readonly rightClicked: (ipa: IpaType) => void,
}) {
  const currentBase = getBestFormantMatch(props.current);
  const referenceBase = getBestFormantMatch(props.reference);

  function whatColor(ipa: IpaType): string {
    if (ipa === props.current || ipa === currentBase) {
      return 'rgb(250,50,100)';
    } else if (ipa === props.reference || ipa === referenceBase) {
      return 'rgb(50,150,250)';
    } else if (props.list && props.list.includes(ipa)) {
      return 'green';
    }
    return 'black';
  }

  const diphthongs = [props.current, props.reference];
  const toShow = props.list ? props.list.concat(diphthongs) : diphthongs;

  return <FormantsChart width={500} height={250}
    diphthongs={toShow} whatColor={whatColor}
    clicked={props.clicked} rightClicked={props.rightClicked} />;
}
